import React, { useMemo } from 'react';
import styles from './unitList.module.scss';
import IconMenu from '@assets/icons/menu.svg?react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';

type Props = {
  name: string;
  selected?: boolean;
  draggableProvided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  onClick?: () => void;
};

function UnitTitle({ draggableProvided, snapshot, name, selected, onClick }: Props) {
  const wrapperClassName = useMemo(() => {
    const classes = [styles.itemWrapper];
    if (selected) {
      classes.push(styles.selected);
    }
    if (snapshot?.isDragging) {
      classes.push(styles.moving);
    }
    return classes.join(' ');
  }, [selected, snapshot?.isDragging]);

  return (
    <div className={wrapperClassName} onClick={onClick} {...draggableProvided?.dragHandleProps}>
      <div className={styles.menu} style={{
        display: snapshot?.isDragging ? "flex" : ""
      }}>
        <IconMenu />
      </div>
      <div className={styles.circle}/>
      <div className={styles.title}>{name}</div>
      <div className={styles.meta}></div>
    </div>
  );
}

export default React.memo(UnitTitle);
